import {ProductCardFile} from 'api/filtersData';
import {apiClient} from 'core/apiClient';
import {AuditExportFormat} from 'types/audit-log';
import {
    ProductCardAuditEntry,
    ProductCardAuditPage,
    ProductCardAuditParams,
} from 'types/product-card-audit';

const URL = '/service/product-cards/audit-log';

export async function fetchProductCardAuditLog(params: ProductCardAuditParams) {
    return (await apiClient.get<ProductCardAuditPage>(URL, {params})).data;
}

export async function fetchProductCardAuditEvent(eventId: string) {
    return (await apiClient.get<ProductCardAuditEntry>(`${URL}/${eventId}`)).data;
}

export async function fetchProductCardAuditErrors(eventId: string) {
    return (await apiClient.get<ProductCardFile>(`${URL}/${eventId}/errors`)).data;
}

export async function exportProductCardAuditEvent(eventId: string) {
    return (await apiClient.get<Blob>(`${URL}/${eventId}/export`, {responseType: 'blob'})).data;
}

export async function exportProductCardAuditLog(
    params: ProductCardAuditParams & {format: AuditExportFormat; from: string; to: string},
) {
    const response = await apiClient.get<Blob>(`${URL}/export`, {params, responseType: 'blob'});
    return {data: response.data};
}
